import {ref} from 'vue';

export default function useModal() {

  const currentModal = ref<string | null>(null);
  const body = document.querySelector('body') as HTMLBodyElement;

  function openModal(name: string) {
    currentModal.value = name;
    body.style.overflow = "hidden";
  }

  function closeModal() {
    currentModal.value = null;
    body.style.overflow = "";
  }

  return {
    currentModal,
    openModal,
    closeModal,
  }
}